import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import './Battery.css';

const Battery = () => {
    const [batteryData, setBatteryData] = useState([]);
    const [batteryName, setBatteryName] = useState('');
    const [batteryWh, setBatteryWh] = useState('');
    const [batteryBrand, setBatteryBrand] = useState('');
    const [batteryPrice, setBatteryPrice] = useState('');
    const [batteryAh, setBatteryAh] = useState('');
    const [batteryDescription, setBatteryDescription] = useState('');
    const navigate = useNavigate();

    const handleWheel = (e) => {
        if (e.target.type === 'number') {
            e.preventDefault();
        }
    };

    React.useEffect(() => {
        window.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
            window.removeEventListener('wheel', handleWheel);
        };
    }, []);

    const handleAddBattery = async (e) => {
        e.preventDefault();

        if (batteryName && batteryWh && batteryBrand && batteryPrice && batteryAh && batteryDescription) {
            const newBattery = {
                name: batteryName,
                Wh: Number(batteryWh),
                Brand: batteryBrand,
                Price: parseFloat(batteryPrice),
                Ah: Number(batteryAh),
                Description: batteryDescription,
            };

            try {
                await addDoc(collection(db, 'Baterias'), newBattery);
                setBatteryData([...batteryData, newBattery]);
                Swal.fire({
                    title: 'Éxito',
                    text: 'Batería registrada con éxito.',
                });
                setBatteryName('');
                setBatteryWh('');
                setBatteryBrand('');
                setBatteryPrice('');
                setBatteryAh('');
                setBatteryDescription('');
                navigate('/admin/baterias/settings');
            } catch (error) {
                Swal.fire({
                    title: 'Error',
                    text: 'Ocurrió un error al registrar la batería.',
                });
            }
        } else {
            Swal.fire({
                title: 'Error',
                text: 'Por favor, rellene todos los campos.',
            });
        }
    };

    return (
        <div className="battery-container">
            <h1 className="battery-title">Registrar Batería</h1>
            <form className="form-battery" onSubmit={handleAddBattery}>

                <div className="input-row-baterry">
                    <label className="label-battery">
                        Modelo
                        <input
                            className="input-battery"
                            type="text"
                            value={batteryName}
                            onChange={(e) => setBatteryName(e.target.value)}
                            required
                        />
                    </label>
                    <label className="label-battery">
                        Marca
                        <input
                            className="input-battery"
                            type="text"
                            value={batteryBrand}
                            onChange={(e) => setBatteryBrand(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <label className="label-battery">
                    Descripción
                    <textarea
                        className="textarea-battery"
                        value={batteryDescription}
                        onChange={(e) => setBatteryDescription(e.target.value)}
                        required
                    />
                </label>
                <div className="input-row-baterry">
                    <label className="label-battery">
                        Wh
                        <input
                            className="input-battery"
                            type="number"
                            value={batteryWh}
                            onChange={(e) => setBatteryWh(e.target.value)}
                            required
                        />
                    </label>
                    <label className="label-battery">
                        Ah
                        <input
                            className="input-battery"
                            type="number"
                            value={batteryAh}
                            onChange={(e) => setBatteryAh(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="input-row-baterry">
                    <label className="label-battery">
                        Precio
                        <input
                            className="input-battery"
                            type="number"
                            step="0.01"
                            value={batteryPrice}
                            onChange={(e) => setBatteryPrice(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="battery-btn-container">
                    <button className="btn-battery" type="submit">Agregar batería</button>
                    <button className="btn-battery" onClick={() => navigate('/admin/baterias/settings')}>Cancelar</button>
                </div>
            </form>
        </div>
    );
};

export default Battery;